import { FormSubmitStatusText } from "components/common/Form/FormSubmitStatusText/FormSubmitStatusText.style";
import { withFormsy } from "formsy-react";
import React, {
  ChangeEvent,
  FocusEvent,
  FunctionComponent,
  SyntheticEvent,
  useState
} from "react";
import { FormInputWrapper } from "./Form.style";

interface IProps {
  name: string;
  value: string;
  isFocused?: boolean;
  setValue(value: string);
  getErrorMessage(): string;
  getValue(): string;
  onChange(event: ChangeEvent<HTMLInputElement>);
  onBlur?(event: FocusEvent<HTMLInputElement>);
}

const FormInput: FunctionComponent<IProps> = props => {
  const [isFocused, setIsFocused] = useState();

  const changeValue = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    // setValue() will set the value of the component, which in
    // turn will validate it  and the rest of the form
    // Important: Don't skip this step. This pattern is required
    // for Formsy to work.
    props.setValue(event.currentTarget.value);
  };

  const handleOnBlur = (event: FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (props.onBlur) {
      props.onBlur(event);
    }
  };

  const handleOnClick = (event: SyntheticEvent<HTMLInputElement>) => {
    setIsFocused(true);
  };

  const errorMessage = props.getErrorMessage();
  return (
    <>
      <FormInputWrapper
        onClick={handleOnClick}
        onChange={changeValue}
        type="text"
        style={
          isFocused
            ? { borderBottom: "4px solid" }
            : { borderBottom: "1px solid" }
        }
        value={props.getValue()}
        onBlur={handleOnBlur}
        {...props}
      />
      <FormSubmitStatusText block error>
        {errorMessage}
      </FormSubmitStatusText>
    </>
  );
};

export default withFormsy<IProps>(FormInput);



// WEBPACK FOOTER //
// ./src/components/common/Form/FormInput.tsx